<template>
  <!-- code here -->
  <div class="card mx-auto">
    <div class="card-img skeleton">
      <!-- waiting for img to load from javascript -->
    </div>
    <div class="card-body">
      <h2 class="card-title skeleton">
        <!-- wating for title to load from javascript -->
      </h2>
      <p class="card-intro skeleton">
        <!-- waiting for intro to load from Javascript -->
      </p>
    </div>
  </div>
</template>


<script>
import {defineComponent} from 'vue'

export default defineComponent({
  name: "ProductSkeleton1"
})
</script>

<style scoped>
.card {
  display: flex;
  flex-direction: column;
  flex-basis: 300px;
  flex-shrink: 0;
  flex-grow: 0;
  max-width: 100%;
  background-color: #FFF;
  box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.15);
  border-radius: 10px;
  overflow: hidden;
  margin: 1rem;
  width: 75%;
}

.card-img {
  padding-bottom: 56.25%;
  position: relative;
}

.card-img img {
  position: absolute;
  width: 100%;
}

.card-body {
  padding: 1.5rem;
}

.card-title {
  font-size: 1.25rem;
  line-height: 1.33;
  font-weight: 700;
}

.card-title.skeleton {
  min-height: 28px;
  border-radius: 4px;
}

.card-intro {
  margin-top: 0.75rem;
  line-height: 1.5;
}

.card-intro.skeleton {
  min-height: 72px;
  border-radius: 4px;
}

.skeleton {
  background-color: #e2e5e7;
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.5), rgba(255, 255, 255, 0));
  background-size: 40px 100%;
  background-repeat: no-repeat;
  background-position: left -40px top 0;
  -webkit-animation: shine 1s ease infinite;
  animation: shine 1s ease infinite;
}

@-webkit-keyframes shine {
  to {
    background-position: right -40px top 0;
  }
}

@keyframes shine {
  to {
    background-position: right -40px top 0;
  }
}
</style>